import {
  SHOW_MODAL_QUERY_PARAM,
  MODAL_IDENTIFIER_QUERY_PARAM,
  CONDUCTOR_MODAL_QUERY_PARAM,
} from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { IAction } from "@faire/web-api--source/indigofair/data/IAction";

type LinkAndActions = {
  link: string | undefined;
  newTabLink: string | undefined;
  nonNavigationActions: IAction[];
};

export function extractLinkFromActions(actions: IAction[]): LinkAndActions {
  const newTabLink = actions.find((action) => action.navigate)?.navigate
    ?.new_tab_link;
  const nonNavigationActions = actions.filter(
    (action) => !action.navigate && !action.open_modal?.open_conductor_modal
  );
  let link = actions.find((action) => action.navigate)?.navigate?.link;

  // the conductor_modal is driven from the query param, so we need to append the query param to the link
  const queryParamAction = actions.find(
    (action) => action.open_modal?.open_conductor_modal
  );
  const queryModalIdentifier =
    queryParamAction?.open_modal?.open_conductor_modal?.conductor_token;

  if (queryModalIdentifier) {
    link = getCurrentPath()
      .append({
        [SHOW_MODAL_QUERY_PARAM]: CONDUCTOR_MODAL_QUERY_PARAM,
        [MODAL_IDENTIFIER_QUERY_PARAM]: queryModalIdentifier,
      })
      .toString();
  }

  return {
    link,
    newTabLink,
    nonNavigationActions,
  };
}
